<template>
    <li :class="{'border-b-xs border-neutral-light': ! isLastStreet}">
        <div class="p-lg flex justify-between">
            <div>
                <checkbox-input
                    v-model="selectedStreet"
                    class="mr-md font-bold"
                    @toggle="selectStreet"
                >
                    {{ streetName }} ({{ addresses.length }})
                </checkbox-input>
            </div>
            <a
                class="cursor-pointer text-neutral-darkest font-bold"
                @click="showAddresses = ! showAddresses"
            >
                <span v-if="showAddresses">Dölj</span>
                <span v-else>Visa</span>
            </a>
        </div>

        <ul v-if="showAddresses" class="list-reset">
            <address-list-item
                v-for="(address, i) in addresses"
                :key="'address_list_item_' + address.id"
                :address="address"
                :selected-addresses="selectedAddresses"
                :assigned-addresses="assignedAddresses"
                :is-last-address="addresses.length - 1 === i"
            />
        </ul>
    </li>
</template>

<script>
    import AddressListItem from './AddressListItem';

    export default {
        components: { AddressListItem },
        props: {
            streetName: {
                type: String,
                required: true,
            },
            addresses: {
                type: [Object, Array],
                required: true,
            },
            selectedAddresses: {
                required: true,
                type: Array,
            },
            assignedAddresses: {
                required: true,
                type: Array,
            },
            isLastStreet: {
                required: true,
                type: Boolean,
            },
        },

        data() {
            return {
                showAddresses: false,
                selectedStreet: false,
            };
        },

        computed: {
            /**
             * "Slugify" the street name so we can use it as an ID
             *
             * @returns {string}
             */
            inputElementId() {
                return this.streetName
                    .toString()
                    .trim()
                    .toLowerCase()
                    .replace(/[\s\W-]+/g, '-');
            },
        },

        watch: {
            selectedAddresses() {
                const amountSelected = this.selectedAddresses.filter(address => address.street_name === this.streetName);

                this.selectedStreet = amountSelected.length === this.addresses.length;
            },
        },

        methods: {
            selectStreet(checked) {
                EventBus.$emit('update-selected-street', this.addresses, checked);
            },
        },
    };
</script>
